/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FichierGridDto } from './FichierGridDto';
import {
    FichierGridDtoFromJSON,
    FichierGridDtoFromJSONTyped,
    FichierGridDtoToJSON,
} from './FichierGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FichierGridDtoPaginatedResults
 */
export interface FichierGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FichierGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FichierGridDto>}
     * @memberof FichierGridDtoPaginatedResults
     */
    results?: Array<FichierGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FichierGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FichierGridDtoPaginatedResults interface.
 */
export function instanceOfFichierGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FichierGridDtoPaginatedResultsFromJSON(json: any): FichierGridDtoPaginatedResults {
    return FichierGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FichierGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FichierGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FichierGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FichierGridDtoPaginatedResultsToJSON(value?: FichierGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FichierGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

